import { PLAN_LABEL, ROLE_LABEL, fmtDate } from "../api";
import { useMe } from "../session";

declare const __BUILD_ID__: string;
declare const __APP_VERSION__: string;

/** Versão e data da compilação (o identificador do build traz AAAAMMDDHHMM; fuso do servidor de build, em UTC). */
function versionText(): string {
  const m = /-(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})-/.exec(__BUILD_ID__);
  const when = m ? ` · compilada em ${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]} UTC` : "";
  return `v${__APP_VERSION__}${when}`;
}

/** "Seu ambiente": dados do plano e do acesso. Fica em Configurações > Geral. */
export function EnvironmentCard() {
  const { me } = useMe();
  const t = me.tenant;
  if (!t) return null;
  return (
    <div className="card" style={{ maxWidth: 560, marginBottom: 16 }}>
      <h3 style={{ fontSize: 16, marginBottom: 14 }}>Seu ambiente</h3>
      <dl className="kv">
        <dt>Ambiente</dt><dd>{t.kind === "pf" ? "Pessoa Física" : "Pessoa Jurídica"} · {t.name}</dd>
        <dt>Plano</dt><dd><span className="pill accent">{PLAN_LABEL[t.plan] ?? t.plan}</span></dd>
        <dt>Moeda principal</dt><dd className="tabular">{t.currency}</dd>
        <dt>Situação</dt><dd>{t.status === "ativo" ? "Ativo" : "Suspenso"}</dd>
        <dt>Perfil</dt><dd>{ROLE_LABEL[me.user.role]}</dd>
        <dt>Último acesso</dt><dd>{fmtDate(me.user.lastLoginAt)}</dd>
        <dt>Versão do sistema</dt><dd className="tabular" title={`Build ${__BUILD_ID__}`}>{versionText()}</dd>
        <dt>Autenticação em 2 fatores</dt><dd>{me.security.totpEnabled ? "Ativada" : "Desativada"}</dd>
      </dl>
    </div>
  );
}
